import { getCurrentDevice } from './utils';

function disableHover() {
	function hasTouch() {
		return 'ontouchstart' in document.documentElement
					 || navigator.maxTouchPoints > 0
					 || navigator.msMaxTouchPoints > 0;
	}

	if (hasTouch() && getCurrentDevice() != 'desktop') { // remove all the :hover stylesheets
		for (let si = 0; si < document.styleSheets.length; si++) {
			const styleSheet = document.styleSheets[si];
			try { // prevent exception on browsers not supporting DOM styleSheets properly
			if (!styleSheet.rules) continue;
			} catch (ex) {
				continue
			}

			for (let ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
				if (!styleSheet.rules[ri].selectorText) continue;

				if (styleSheet.rules[ri].selectorText.match(':hover')) {
					styleSheet.deleteRule(ri);
				}
			}
		}
	}
}

export default disableHover;